import React from 'react'
import { Redirect, Route } from 'react-router'
import {
  OVERLAY_ROUTES,
  overlayRedirectLocation,
} from 'src/navigation/overlayRoutes'

// Renders one redirect `<Route>` per overlay URL route (see `overlayRoutes.ts`),
// rewriting each dedicated, pretty overlay URL to its query-param form so the
// overlay opens over its page. This is what lets us keep human-readable,
// shareable URLs for modals/flyouts (and keep any existing deep link / `<Lnk>`
// trigger working) while the overlay itself is driven by query params. The
// mappings — and the collision guard against flat page routes — live in
// `overlayRoutes.ts`.
const OverlayRedirects: React.FC = () => (
  <>
    {OVERLAY_ROUTES.map((route) => (
      <Route
        key={route.path}
        exact
        path={route.path}
        render={({ match }): React.ReactElement => (
          <Redirect
            to={overlayRedirectLocation(
              route,
              match.params as Record<string, string>,
            )}
          />
        )}
      />
    ))}
  </>
)

export default OverlayRedirects
